<div class="image-list">
    @for (image of images(); track image; let idx = $index) {
        <img
            class="responsive-image"
            [class.calculated-height]="calculatedHeight()"
            imgFallback
            [alt]="label()"
            [attr.aria-label]="'slide ' + (idx + 1) + ' of ' + images()?.length + ',' + label()"
            [inputSrcSet]="image"
        />
    }
</div>
